import { render, staticRenderFns } from "./benefitclaim.vue?vue&type=template&id=6e250969"
import script from "./benefitclaim.vue?vue&type=script&lang=js"
export * from "./benefitclaim.vue?vue&type=script&lang=js"
import style0 from "./benefitclaim.vue?vue&type=style&index=0&id=6e250969&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports